module.exports = __webpack_public_path__ + "img/Unclear Stamp.6a668908.png";